angular.module('inspinia').directive('baseAlert', () => {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      text: '@',
    },
    transclude: true,
    templateUrl: `/manage/src/view/directive/base_alert.html?${new Date().getTime()}`,
    link($scope) {
      switch ($scope.type) {
        case 'warning':
          $scope.iconName = 'warning';
          $scope.alertType = 'warning';
          break;
        case 'error':
          $scope.iconName = 'alert-circle';
          $scope.alertType = 'error';
          break;
        case 'success':
          $scope.iconName = 'checkmark-circle';
          $scope.alertType = 'success';
          break;
        case 'info':
          $scope.iconName = 'information-circle';
          $scope.alertType = 'info';
          break;
        default:
          console.error('BaseAlert type not found');
      }
      $scope.viewType = $scope.text !== undefined ? 'alertText' : 'alertBox';
    },
  };
});
